import type { CatalogueWrite } from './catalogue';

export type WriteOutcome =
  | { kind: 'published'; version: number | string }
  | { kind: 'unaudited'; version: number | string | undefined }
  | { kind: 'conflict'; status: 409 | 412 }
  | { kind: 'rejected'; status: number; reason?: string }
  // The request never reached the server (network down, CORS preflight refused, DNS). Nothing
  // was written, so the item stays pending and a retry is safe — keeps makePut total so a failed
  // fetch surfaces as a report row rather than rejecting the whole publish.
  | { kind: 'unreachable' };

export type PutFn = (write: CatalogueWrite) => Promise<WriteOutcome>;
export type PublishReport = { id: string; outcome: WriteOutcome }[];

// Sequential: writes are pre-ordered tiers->modules->offers so references resolve. No item
// stops another; the server enforces references and re-publish reuses the shrinking diff.
export async function publishPackaging(writes: CatalogueWrite[], put: PutFn): Promise<PublishReport> {
  const report: PublishReport = [];
  for (const write of writes) report.push({ id: write.id, outcome: await put(write) });
  return report;
}
